"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.RSADefaults = void 0;
//import { JSEncryptRSA } from './JSEncryptRSA';
const NodeRSA_1 = require("./NodeRSA");
const WebCryptoRSA_1 = require("./WebCryptoRSA");
class RSADefaults {
}
exports.RSADefaults = RSADefaults;
RSADefaults.impl = ((_a = globalThis === null || globalThis === void 0 ? void 0 : globalThis.crypto) === null || _a === void 0 ? void 0 : _a.subtle) !== undefined ? WebCryptoRSA_1.WebCryptoRSA : NodeRSA_1.NodeRSA;
//# sourceMappingURL=RSA.js.map